<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path d="M13.794 6.692c.969 0 1.754-.827 1.754-1.846 0-1.02-.785-1.846-1.754-1.846-.968 0-1.754.826-1.754 1.846s.786 1.846 1.754 1.846Zm-.508 10.15a3.133 3.133 0 0 1-3.091 2.681 3.141 3.141 0 0 1-3.138-3.138 3.14 3.14 0 0 1 1.892-2.877l.188-1.604A4.608 4.608 0 0 0 10.195 21c2.392 0 4.335-1.826 4.569-4.157h-1.478Z"/>
    <path d="M17.117 13.153c.477 0 .876.364.92.839l.46 5.076-1.838.168-.386-4.237h-3.034l-1.568-.003a.924.924 0 0 1-.917-1.03l.526-4.505H9.85a.554.554 0 0 0-.55.49l-.139 1.19-1.835-.215.139-1.19A2.4 2.4 0 0 1 9.85 7.615h4.038a.922.922 0 0 1 .917 1.03l-.528 4.507h2.84Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
